// extracted by mini-css-extract-plugin
export var emailBlockLink = "_oc-0";